import { render, staticRenderFns } from "./RefAgent.vue?vue&type=template&id=3521a142&scoped=true&"
import script from "./RefAgent.vue?vue&type=script&lang=js&"
export * from "./RefAgent.vue?vue&type=script&lang=js&"
import style0 from "./RefAgent.vue?vue&type=style&index=0&id=3521a142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521a142",
  null
  
)

export default component.exports